/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import { onClickGoogleAnalyticsEvent } from '../utils/ga-utils';
import Observe from '../utils/mutationUtils';
import { BiButton, BiButtonGroup, BiTypography } from 'bi-web-components-react';
import { useTranslation } from 'react-i18next';
import type { ComponentSelector } from '../types';
import { Pending } from '@bino/utils/components/pending';

export type ChooseYourPathProps = {
    setComponent: (val: ComponentSelector) => void;
    clickDaButt: (category: string, action: string, label: string, startChatForm: any) => void;
};

type State = {
    waitingChat: boolean;
};

declare let embedded_svc: any;
declare let portalURL: string;
declare let chatParams: any | null;

const chatClass = 'stateBody embeddedServiceSidebarState';
export default function ChooseYourPath({ setComponent, clickDaButt }: ChooseYourPathProps) {
    const { t } = useTranslation('chat');
    const [state, setState] = useState<State>({ waitingChat: false });

    useEffect(() => {
        if (chatParams?.contactUsOpen) {
            openChat();
        }
        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function openChat() {
        setState((prev) => ({ ...prev, waitingChat: !state.waitingChat }));

        try {
            embedded_svc.onHelpButtonClick();
            Observe(chatClass, clickDaButt);
        } catch {
            //console.log(e);
        } finally {
            onClickGoogleAnalyticsEvent('Chat', 'Chat with us - start chat', window.location.href);
        }
    }

    function goToUrl() {
        window.location.href = portalURL;
        onClickGoogleAnalyticsEvent('Chat', 'Chat with us - log in', 'Login');
    }

    function navigateToFront() {
        setComponent('front');
    }

    if (chatParams?.contactUsOpen) {
        return <Pending />;
    }

    return (
        <div className='chooseYourPath'>
            <div className='maintext'>
                <h2>{t('areYouStudent')}</h2>
                <BiTypography>
                    <p className='chooseYourPath-text'>{t('studentDesc')}</p>
                </BiTypography>
            </div>
            <div className='chooseYourPath-button-container'>
                <BiButtonGroup direction='vertical' alignment='center'>
                    <BiButton stretch onClick={goToUrl} aria-label={t('logIn')}>
                        {t('logIn')}
                    </BiButton>
                    <BiButton stretch onClick={openChat} submitting={state.waitingChat} aria-label={'Start chat'}>
                        Start chat
                    </BiButton>
                    <BiButton variant='text' onClick={navigateToFront}>
                        {t('cancel')}
                    </BiButton>
                </BiButtonGroup>
            </div>
        </div>
    );
}
